/* this file added by Bearer Web Developer  */
import { observer } from "mobx-react-lite";
import React, { useEffect } from 'react';
import { useAppState } from "../../../../states/app-state";
import styles from './payment.module.scss';
import { TCardInformation } from "../../../../api/bearer-api";
import getImageOfCart from "../../../price/ImageOfCard";
import { Button } from "@mui/material";

interface Props {
    setLoading: React.Dispatch<React.SetStateAction<boolean>>
    cardInformation: TCardInformation
}
const Payment: React.FC<Props> = observer(({ setLoading, cardInformation }) => {
    const appState = useAppState();
    
    const order = appState.selectedOrder;

    const handleEdit = () => {
        if (!appState.login.loggedin) {
            return;
        } else {
            appState.selectedOrder?.payment?.setHasPayButton(false);
            appState.selectedOrder?.payment.setOpen(order!);
        }
    }
    const handlePay = async () => {
        setLoading(true);
        await appState.selectedOrder?.payment.paymentAuthorization();
        setLoading(false);
    }

    useEffect(() => {
        appState.selectedOrder?.payment.selectCard(cardInformation);
    }, [])
    return (
        <div className={styles.payment_part}>
            <div className={styles.card}>
                <div className={styles.card_information_visa}>
                    {getImageOfCart(cardInformation)}
                </div>
                <span className={styles.text}> XXXX {cardInformation.last4}</span>
                <span className={styles.text}>{cardInformation.exp_month}/{cardInformation.exp_year}</span>
                <div onClick={handleEdit} className={styles.edit}>
                    <img src="/edit.svg" alt="" width={24} height={24} />
                </div>
            </div>
            <Button className={styles.payment} onClick={handlePay} disabled={!order?.isReadyForPayment}
                classes={{ text: styles.payment_label }}
            >
                Pay
            </Button>

        </div>


    );
})
export default Payment;


